export default {
  discount_badge: '{{value}} alennus',
  high_caffeine_warning_required: 'Runsaasti kofeiinia',
  pfand: 'Sis. {{value}} pantti',
  alcohol_by_volume_percent: '{{value}} % alkoholia',
};
